import { useEffect, useState } from 'react';
import { plateformeApi } from '../../api/resources';
import { Shell } from '../../components/layout/Shell.jsx';
import { quandOuvert } from '../../components/CarteLienClient.jsx';
import { trf } from '../../lib/i18n';
import { C } from '../../theme/palette';

/**
 * Inscriptions à SwissTech, pour son créateur : chaque compte créé et chaque
 * tentative refusée, avec l'adresse e-mail, le téléphone, le nom et
 * l'entreprise. Le serveur refuse la liste à tout autre compte.
 *
 * @param {object} props propriétés de la page
 * @returns {JSX.Element} la page
 */
export function InscriptionsPage({ onNav, soc, estMixte, univers, setUnivers }) {
  const [liste, setListe] = useState(null);
  const [erreur, setErreur] = useState('');

  useEffect(() => {
    let vivant = true;
    Promise.resolve()
      .then(() => plateformeApi.inscriptions())
      .then((l) => {
        if (vivant) setListe(Array.isArray(l) ? l : []);
      })
      .catch((e) => {
        if (vivant) setErreur(e?.message || 'La liste n’a pas pu être lue.');
      });
    return () => {
      vivant = false;
    };
  }, []);

  const creees = (liste || []).filter((i) => i.resultat === 'CREE').length;

  return (
    <Shell
      active="plus"
      onNav={onNav}
      soc={soc}
      back
      onBack={() => onNav('plus')}
      estMixte={estMixte}
      univers={univers}
      setUnivers={setUnivers}
      pageTitle="🆕 Inscriptions SwissTech"
    >
      <div
        style={{
          background: C.navyXL,
          border: '1px solid ' + C.border,
          borderRadius: 11,
          padding: '11px 13px',
          marginBottom: 12,
          fontSize: 10,
          color: C.grey,
          lineHeight: 1.5,
        }}
      >
        <b style={{ color: C.ink }}>🔒 Réservé au créateur de SwissTech.</b> Chaque compte créé, et
        chaque tentative refusée, avec le nom, l’e-mail, le téléphone et l’adresse.
        {liste && (
          <div style={{ marginTop: 4, color: C.ink }}>{trf('{0} compte(s) créé(s)', creees)}</div>
        )}
      </div>
      {erreur && (
        <div role="alert" style={{ fontSize: 11, color: C.red }}>
          {erreur}
        </div>
      )}
      {!erreur && liste === null && (
        <div role="status" style={{ fontSize: 11, color: C.muted, textAlign: 'center' }}>
          Chargement…
        </div>
      )}
      {liste && liste.length === 0 && (
        <div style={{ fontSize: 11, color: C.muted, textAlign: 'center', padding: '30px 0' }}>
          Aucune inscription pour l’instant.
        </div>
      )}
      {(liste || []).map((i, n) => {
        const ok = i.resultat === 'CREE';
        return (
          <div
            key={i.le + '-' + n}
            data-testid="inscription"
            style={{
              background: C.white,
              border: '1px solid ' + C.border,
              borderLeft: '3px solid ' + (ok ? C.green : C.amber),
              borderRadius: 10,
              padding: '10px 12px',
              marginBottom: 7,
              fontSize: 10.5,
              lineHeight: 1.5,
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
              <b style={{ minWidth: 0, overflowWrap: 'anywhere' }}>{i.entreprise || '—'}</b>
              <span style={{ color: ok ? C.green : C.amber, fontWeight: 800, flexShrink: 0 }}>
                {ok ? '✓ Compte créé' : '⚠ Tentative refusée'}
              </span>
            </div>
            <div>{i.nom}</div>
            <div style={{ overflowWrap: 'anywhere' }}>
              📧 <a href={'mailto:' + i.email}>{i.email}</a>
            </div>
            {i.telephone && (
              <div>
                📞 <a href={'tel:' + i.telephone.replace(/\s/g, '')}>{i.telephone}</a>
              </div>
            )}
            {(i.adresse || i.npa) && (
              <div style={{ overflowWrap: 'anywhere' }}>
                📍 {[i.adresse, i.npa].filter(Boolean).join(', ')}
              </div>
            )}
            {!ok && i.motif && <div style={{ color: C.grey }}>{i.motif}</div>}
            <div style={{ color: C.muted, fontSize: 9 }}>{quandOuvert(i.le)}</div>
          </div>
        );
      })}
    </Shell>
  );
}
